<template>
	<div class="graph">
		<ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs>
		<DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<Graph1D
			v-bind:data="activityOccurrences"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</Graph1D>
	</div>
</template>

<script>
import Graph from './index'

export default {
	name: 'activity-graph',
	extends: Graph,

	computed: {
		/**
		 * @function 	activityOccurrences
		 * @desc 		To get the timestamp when the activity event was 'created'
		 */
		activityOccurrences() {
			return this.data.map((activity) => activity.created)
		}
	}
}
</script>
